/* eslint-disable max-lines-per-function */
import {defineCustomElement} from 'custom-extensions/utils';
import {LitElement, html, nothing} from 'lit';
import {styleMap} from 'lit/directives/style-map.js';
import {classMap} from 'lit/directives/class-map.js';
import styles from './FreeShippingBar.component.scss?as=stylesheet';
import head from './head.svg';
import emptyHead from './empty-head.svg';
import jizz from './jizz.svg';

export class FreeShippingBar extends LitElement {
	static styles = [styles];

	static get properties () {
		return {
			qualifies: {
				type: Number
			},
			qualifyingAmount: {
				attribute: 'qualifying-amount',
				type: Number
			},
			threshold: {
				type: Number
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {Number}
		 */
		this.qualifies = 0;

		/**
		 * @type {Number}
		 */
		this.qualifyingAmount = 0;

		/**
		 * @type {Number}
		 */
		this.threshold = 0;
	}

	render () {
		const classes = {
			'free-shipping': true,
			'free-shipping-bar__empty': !this.qualifyingAmount,
			'free-shipping-bar__qualifying': this.qualifies
		};

		const fillStyles = {
			width: this.width
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="free-shipping__inner">
					<div class="free-shipping-text">${this.renderText()}</div>
					<div class="free-shipping-bar">
						<span class="free-shipping-bar__low">${this.formatPrice(this.qualifyingAmount)}</span>
						<div class="free-shipping-bar__bar">
							<div class="free-shipping-bar__background"></div>
							<div class="free-shipping-bar__fill" style="${styleMap(fillStyles)}"></div>
							<div class="free-shipping-bar__penis">
								<div class="free-shipping-bar__shaft"></div>
								<div class="free-shipping-bar__head">
									<img src="${this.qualifyingAmount ? head : emptyHead}" loading="lazy" />
								</div>
							</div>
							${this.renderJizz()}
						</div>
						<span class="free-shipping-bar__low">${this.formatPrice(this.threshold)}</span>
					</div>
				</div>
			</div>
		`;
	}

	renderJizz () {
		if (!this.qualifies) {
			return nothing;
		}

		return html`
			<div class="free-shipping-bar__jizz">
				<img src="${jizz}" loading="lazy" />
			</div>
		`;
	}

	get width () {
		let width = (this.threshold - this.amountLeft) / this.threshold * 100;
		if (width >= 100) {
			width = 100;
		}
		return `${width.toFixed(2)}%`;
	}

	get amountLeft () {
		return this.threshold - this.qualifyingAmount;
	}

	renderText () {
		if (this.qualifies) {
			return html`Congrats! You have earned <span class="highlight">Free Shipping!</span>`;
		}

		return html`You're only <span class="highlight">${this.formatPrice(this.amountLeft)}</span> from Free Shipping!`;
	}

	formatPrice (amount) {
		return new Intl.NumberFormat('en-US', {
			currency: 'USD',
			style: 'currency'
		}).format(amount);
	}

};

defineCustomElement('x-free-shipping-bar', FreeShippingBar);
